import React from 'react';
import { useHistory } from 'react-router-dom';
import { Chapter } from '../../interfaces/chapters.interface';
import { confirmDialog } from 'primereact/confirmdialog';
import ChapterService from '../../service/ChapterService';

interface ChaptersListProps {
  chapters: Chapter[];
  transporterId: string;
  onChapterDeleted: () => void;
}

const ChaptersList: React.FC<ChaptersListProps> = ({ chapters, transporterId, onChapterDeleted }) => {
  const history = useHistory();
  const chapterService = new ChapterService();

  const isChapterEditable = (chapter: Chapter) => {
    return chapter.transporters.includes(transporterId);
  };

  const handleEdit = (chapterId: string) => {
    history.push(`/chapters/edit/${chapterId}`);
  };

  const handleDelete = (chapter: Chapter) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer ce chapitre ?',
      header: 'Confirmation de suppression',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: async () => {
        try {
          await chapterService.deleteChapter(chapter._id);
          onChapterDeleted();
        } catch (error) {
          console.error('Error deleting chapter:', error);
        }
      }
    });
  };

  if (chapters.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow">
        <div className="p-6">
          <p className="text-gray-600">
            Aucun chapitre créé. Commencez à créer vos chapitres personnalisés pour vos formations.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow">
      <div className="p-6">
        <div className="space-y-4">
          {chapters.map((chapter) => (
            <div
              key={chapter._id}
              className="border rounded-lg p-4 hover:shadow-md transition-shadow"
            >
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="text-lg font-semibold">{chapter.title}</h3>
                  <p className="text-sm text-gray-600 mt-1">{chapter.category}</p>
                  <p className="mt-2">{chapter.description}</p>
                </div>
                {isChapterEditable(chapter) && (
                  <div className="flex space-x-2">
                    <button
                      onClick={() => handleEdit(chapter._id)}
                      className="p-2 text-blue-600 hover:bg-blue-50 rounded-full transition-colors"
                      title="Modifier"
                    >
                      <i className="ph-bold ph-pencil-simple text-xl"></i>
                    </button>
                    <button
                      onClick={() => handleDelete(chapter)}
                      className="p-2 text-red-600 hover:bg-red-50 rounded-full transition-colors"
                      title="Supprimer"
                    >
                      <i className="ph-bold ph-trash text-xl"></i>
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChaptersList;
